var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentDayTemplate !=null)?_c('DropDownMenu',{attrs:{"menus":_vm.menus}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }